import { Tabs, TabList, Tab, TabPanels, TabPanel } from "@chakra-ui/react";
import ProfileTab from "./ProfileTab";
import MembersTab from "./MembersTab";
import WalletTab from "./WalletTab";
import TransactionsTab from "./TransactionsTab";

/**
 * Tabs container inside the group detail drawer.
 * @param {Object} props - { detail, onRefresh, onChanged, userRight }
 */
function GroupDetailTabs({ detail, onRefresh, onChanged, userRight }) {
    const memberCount = (detail?.members || []).length;
    const txCount = (detail?.transactions || []).length;
    return (
        <Tabs colorScheme="brand" variant="line" isLazy>
            <TabList overflowX="auto" borderColor="whiteAlpha.200">
                <Tab fontSize="0.8rem" fontWeight="600">Profil</Tab>
                <Tab fontSize="0.8rem" fontWeight="600">Membres ({memberCount})</Tab>
                <Tab fontSize="0.8rem" fontWeight="600">Wallet & Finance</Tab>
                <Tab fontSize="0.8rem" fontWeight="600">Transactions ({txCount})</Tab>
            </TabList>
            <TabPanels>
                <TabPanel px="0"><ProfileTab detail={detail} /></TabPanel>
                <TabPanel px="0"><MembersTab detail={detail} onRefresh={onRefresh} onChanged={onChanged} /></TabPanel>
                <TabPanel px="0"><WalletTab detail={detail} onRefresh={onRefresh} onChanged={onChanged} userRight={userRight} /></TabPanel>
                <TabPanel px="0"><TransactionsTab detail={detail} onRefresh={onRefresh} /></TabPanel>
            </TabPanels>
        </Tabs>
    );
}

export default GroupDetailTabs;
